import { showFailToast, showSuccessToast, showToast } from "vant";


export const message = (type, text) => {
    if (type) {
        showSuccessToast({
            message: text,
            position: 'top',
            // closeOnClick:true, // 点击后关闭
            // closeOnClickOverlay:true, // 点击遮罩后关闭
            duration: 1500, // 展示时长
        });
    } else {
        showFailToast({
            message: text,
            position: 'top',
            duration: 1500, // 展示时长
        });
    }
}
